import { ChatPanel } from './ChatPanel';
import type { ChatMessage } from '@/hooks/useChat';

interface ChatWidgetProps {
  isOpen: boolean;
  messages: ChatMessage[];
  isLoading: boolean;
  onSend: (message: string) => void;
  onClose: () => void;
}

export function ChatWidget({ isOpen, messages, isLoading, onSend, onClose }: ChatWidgetProps) {
  return (
    <>
      {/* Slide-out panel */}
      <div
        className={`
          fixed top-0 right-0 h-full w-[400px] max-w-[calc(100vw-1rem)]
          bg-background border-l shadow-2xl z-50
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
        `}
        aria-hidden={!isOpen}
      >
        <ChatPanel
          messages={messages}
          isLoading={isLoading}
          onSend={onSend}
          onClose={onClose}
        />
      </div>

      {/* Backdrop (mobile) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-40 sm:hidden"
          onClick={onClose}
        />
      )}
    </>
  );
}
